import { LogLevel } from '@environment/enums/log-level.enum';
import { captureSentryMessage } from '@shared/sentry';
import { ONE_SECOND_MS } from '@shared/utils';
import { getPlatformInfo } from '../utils';

const KEEP_ALIVE_INTERVAL_MS = ONE_SECOND_MS * 20;
// Keep this 5 because mostly chrome deactivates the extension after 5 minutes of inactivity
const KEEP_ALIVE_ALARM_INTERVAL_MINUTES = 5;

export function startHandlingKeepAlive(): void {
  const keepAliveInterval = () => setInterval(getPlatformInfo, KEEP_ALIVE_INTERVAL_MS);
  chrome.runtime.onStartup.addListener(keepAliveInterval);
  keepAliveInterval();

  // This should awake the service worker
  chrome.alarms.onAlarm.addListener(() => {
    const currentDate = new Date();
    const isoDateString = currentDate.toISOString();
    captureSentryMessage(`Keep-Alive alarm fired! ${isoDateString}`, {}, LogLevel.Debug);
    getPlatformInfo();
  });

  captureSentryMessage(`Keep-Alive alarm registered at interval: ${KEEP_ALIVE_ALARM_INTERVAL_MINUTES} minutes`);
  chrome.alarms.create('keepAlive', {
    delayInMinutes: KEEP_ALIVE_ALARM_INTERVAL_MINUTES,
    periodInMinutes: KEEP_ALIVE_ALARM_INTERVAL_MINUTES,
  });
}
